import {
  EventApi as ChiRhosEventApi,
  EventSeriesApi as ChiRhosEventSeriesApi,
  EventTypeApi as ChiRhosEventTypeApi,
  GroupApi as ChiRhosGroupApi,
  GroupTypeApi as ChiRhosGroupTypeApi,
  ImportApi as ChiRhosImportApi,
  NoteApi as ChiRhosNoteApi,
  NotificationApi as ChiRhosNotificationApi,
  PersonApi as ChiRhosPersonApi,
  RelationshipApi as ChiRhosRelationshipApi,
  RelationshipTypeApi as ChiRhosRelationshipTypeApi,
  RoleApi as ChiRhosRoleApi,
  SecurityApi as ChiRhosSecurityApi,
  SubscriptionApi as ChiRhosSubscriptionApi,
  TemplateApi as ChiRhosTemplateApi,
  TenantApi as ChiRhosTenantApi,
  TestResponseApi as ChiRhosTestResponseApi,
  TransactionApi as ChiRhosTransactionApi,
  UserApi as ChiRhosUserApi,
  Configuration,
} from '@chirhos/chirhos-api-v3'

export default class ChiRhosClientV3 {
  constructor(options = {}) {
    this.basePath = options.basePath
  }
  api() {
    var basePath = this.basePath
    var _apiBasePath = process.env.VUE_APP_CHIRHOS_DOMAIN

    var _identity = getSavedState('auth.identity')
      ? getSavedState('auth.identity')
      : {}

    var _chirhosConfig = getSavedState('chirhos.config')
      ? getSavedState('chirhos.config')
      : {}

    var accessToken = _identity ? _identity.accessToken || '' : ''

    if (!accessToken) {
      throw new Error('Please provide an access token.')
    }

    if (basePath) _apiBasePath = basePath.replace(/\/+$/, '')

    if (_chirhosConfig && _chirhosConfig.apiUrl) {
      _apiBasePath = _chirhosConfig.apiUrl
    }

    var configuration = new Configuration({
      basePath: _apiBasePath,
      accessToken: accessToken,
    })

    var preMiddleware = function(request) {
      request.init.headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      }

      return request
    }

    const EventApi = new ChiRhosEventApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const EventSeriesApi = new ChiRhosEventSeriesApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const EventTypeApi = new ChiRhosEventTypeApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const GroupApi = new ChiRhosGroupApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const GroupTypeApi = new ChiRhosGroupTypeApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const ImportApi = new ChiRhosImportApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const NoteApi = new ChiRhosNoteApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const NotificationApi = new ChiRhosNotificationApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const PersonApi = new ChiRhosPersonApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const RelationshipApi = new ChiRhosRelationshipApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const RelationshipTypeApi = new ChiRhosRelationshipTypeApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const RoleApi = new ChiRhosRoleApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const SecurityApi = new ChiRhosSecurityApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const SubscriptionApi = new ChiRhosSubscriptionApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const TemplateApi = new ChiRhosTemplateApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const TenantApi = new ChiRhosTenantApi(configuration).withPreMiddleware(
      preMiddleware
    )
    const TestResponseApi = new ChiRhosTestResponseApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const TransactionApi = new ChiRhosTransactionApi(
      configuration
    ).withPreMiddleware(preMiddleware)
    const UserApi = new ChiRhosUserApi(configuration).withPreMiddleware(
      preMiddleware
    )

    return {
      EventApi,
      EventSeriesApi,
      EventTypeApi,
      GroupApi,
      GroupTypeApi,
      ImportApi,
      NoteApi,
      NotificationApi,
      PersonApi,
      RelationshipApi,
      RelationshipTypeApi,
      RoleApi,
      SecurityApi,
      SubscriptionApi,
      TemplateApi,
      TenantApi,
      TestResponseApi,
      TransactionApi,
      UserApi,
    }
  }
}

// retrieve content from local storage for a given key
function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

ChiRhosClientV3.instance = new ChiRhosClientV3()
